import React from 'react';
import styled from 'styled-components';
import Highcharts from 'highcharts';
import PieChart from "highcharts-react-official";

const ComplexPieChart = ({ data, width, height, title, justifyContent }) => {
  var options = {
    chart: {
      width: width,
      height: height,
      type: 'pie',
    },
    title: {
      text: title
    },
    tooltip: {
      pointFormat: 'Porcentagem de acertos: <b>{point.percentage:.1f}%</b>'
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: {
          enabled: true,
          format: '<b>{point.name}</b>: {point.percentage:.1f} %'
        },
        showInLegend: false
      }
    },
    series: [
      {
        lineWidth: 1,
        marker: {
          enabled: false,
          symbol: "circle",
          radius: 3,
          states: {
            hover: {
              enabled: true,
              lineWidth: 1
            }
          }
        },
        data: data && data
      }
    ]
  };

  return (
    <div
      style={{
        width: '97.5%',
        borderRadius: '8px',
        padding: '1rem',
        display: 'flex',
        justifyContent: justifyContent,
      }}
    >
      <div>
        <PieChart highcharts={Highcharts} options={options} />
      </div>
    </div>
  );
};

export default styled(ComplexPieChart)`
  display: flex;
  width: 100%;
  height: 100%;
  background-color: #3e2;
  .div {
    color: #3e2;
  }
`;
